import React, { useState } from "react";
import {
  Box, Container, Typography, Accordion, AccordionSummary,
  AccordionDetails, Chip,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { useTheme } from "../../../context/ThemeContext";

const FAQSection = () => {
  const { theme } = useTheme();
  const [expanded, setExpanded] = useState(false);

  const faqs = [
    { question: "What services does OwnerTenantSolution provide?", answer: "We provide property management services to owners (PKR 500/month per property) and assist tenants in finding and booking rental properties (5% commission on confirmed bookings)." },
    { question: "How much does a property owner pay?", answer: "A fixed monthly fee of PKR 500 per property, regardless of the number of tenant inquiries received." },
    { question: "What commission is charged to tenants?", answer: "A 5% commission is applied to the confirmed rental amount at the time of successful booking." },
    { question: "What happens to my booking payment if I don't get the flat?", answer: "Your booking amount is held securely in our platform wallet. If the property owner selects another applicant, your full payment is automatically refunded within 3–7 business days." },
    { question: "Is my payment information secure?", answer: "Yes. All payments are processed through encrypted, secure gateways. OwnerTenantSolution does not store any card or banking information." },
    { question: "Are property listings verified?", answer: "Yes. We conduct basic verification of property owners and their listings to ensure tenants receive authentic and accurate information." },
    { question: "What should I do in case of a dispute?", answer: "Please contact our support team at ownertenantsolution@gmail.com. We aim to respond within 24–48 business hours and facilitate a fair resolution." },
    { question: "Can an owner list multiple properties?", answer: "Yes. Owners can list as many properties as they wish. Each property is charged separately at PKR 500 per month." },
    { question: "Is OwnerTenantSolution available across all of Pakistan?", answer: "We are currently operating in Karachi and plan to expand to additional cities in the near future." },
  ];

  return (
    <Box id="faqs" sx={{ py: { xs: 8, md: 12 } }}>
      <Container maxWidth="md">
        {/* Header */}
        <Box sx={{ textAlign: "center", mb: 7 }}>
          <Chip
            icon={<HelpOutlineIcon />}
            label="FAQs"
            sx={{ bgcolor: theme.lightBg, color: theme.primary, fontWeight: 600, mb: 2, px: 1 }}
          />
          <Typography variant="h3" fontWeight={700} sx={{ color: "#1a1a2e", mb: 1.5 }}>
            Frequently Asked Questions
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 500, mx: "auto" }}>
            Everything you need to know about renting or listing with OTS.
          </Typography>
          <Box sx={{ width: 60, height: 4, bgcolor: theme.primary, mx: "auto", mt: 3, borderRadius: 99 }} />
        </Box>

        {/* Accordion */}
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
          {faqs.map((faq, index) => (
            <Accordion
              key={index}
              expanded={expanded === index}
              onChange={() => setExpanded(expanded === index ? false : index)}
              disableGutters
              elevation={0}
              sx={{
                border: "1px solid",
                borderColor: expanded === index ? theme.primary : "#eee",
                borderRadius: "12px !important",
                overflow: "hidden",
                transition: "border-color 0.2s",
                "&::before": { display: "none" },
              }}
            >
              <AccordionSummary
                expandIcon={
                  <ExpandMoreIcon sx={{
                    color: expanded === index ? theme.primary : "#999",
                    transition: "transform 0.3s",
                  }} />
                }
                sx={{
                  px: 3, py: 1,
                  bgcolor: expanded === index ? `${theme.primary}06` : "white",
                  transition: "background 0.2s",
                  "&:hover": { bgcolor: `${theme.primary}05` },
                }}
              >
                <Typography fontWeight={600} sx={{ color: expanded === index ? theme.primary : "#1a1a2e" }}>
                  {faq.question}
                </Typography>
              </AccordionSummary>
              <AccordionDetails sx={{ px: 3, pt: 0, pb: 2.5, bgcolor: `${theme.primary}04` }}>
                <Typography color="text.secondary" sx={{ lineHeight: 1.8 }}>
                  {faq.answer}
                </Typography>
              </AccordionDetails>
            </Accordion>
          ))}
        </Box>
      </Container>
    </Box>
  );
};

export default FAQSection;